import { lazy } from 'react';
import withSuspense from '../../../helpers/withSuspense';
import InputSkeleton from '../../../skeleton_loaders/common/InputSkeleton.jsx';

const FormulaEditor = withSuspense(lazy(() => import('./FormulaEditor.jsx')), InputSkeleton)

export default FormulaEditor;
